/**
 * Cives Hub Backend Authentication API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { HttpHeaders }                                       from '@angular/common/http';

import { Observable }                                        from 'rxjs';

import { ComunicazioneOutboxDTO } from '../model/models';
import { ComunicazioneOutboxListFilter } from '../model/models';
import { ExceptionResponseDTO } from '../model/models';
import { GetProfiloServizio409Response } from '../model/models';
import { GetProfiloServizio422Response } from '../model/models';
import { Pageable } from '../model/models';
import { PagedModelComunicazioneOutboxDTO } from '../model/models';


import { Configuration }                                     from '../configuration';


export interface ListComunicazioniOutboxRequestParams {
    filter: ComunicazioneOutboxListFilter;
    pageable: Pageable;
}

export interface ReinviaComunicazioneOutboxRequestParams {
    id: string;
}


export interface CodaComunicazioniServiceInterface {
    defaultHeaders: HttpHeaders;
    configuration: Configuration;

    /**
     * Lista paginata della coda comunicazioni (SUPERADMIN).
     * Filtri opzionali: comune_id, tipo_pratica_id, codice_pratica, canale, evento, stato, da/a sull\&#39;istante di accodamento. Ordinamento predefinito: created_at DESC, size 20. Gli stati sono PENDENTE e IN_CORSO (ancora in lavorazione), INVIATA, FALLITA_DEFINITIVA (tentativi esauriti, reinviabile) e SALTATA_NO_RECAPITO (il destinatario non ha un recapito per il canale: si risolve correggendo l\&#39;anagrafica della domanda, non rilanciando). La risposta NON contiene destinatario, testo del messaggio né dati anagrafici: la riga di coda non li memorizza. Le righe chiuse spariscono dopo la finestra di ritenzione configurata.
     * @endpoint get /api/v1/gestione/comunicazioni-outbox
* @param requestParameters
     */
    listComunicazioniOutbox(requestParameters: ListComunicazioniOutboxRequestParams, extraHttpRequestParams?: any): Observable<PagedModelComunicazioneOutboxDTO>;

    /**
     * Rimette in coda una comunicazione fallita definitivamente (SUPERADMIN).
     * Azzera i tentativi e riporta la riga a PENDENTE: il primo giro del worker la riprende. Non modifica alcun dato della domanda. Ammesso SOLO da FALLITA_DEFINITIVA — rilanciare una riga in attesa la duplicherebbe, una già inviata produrrebbe un secondo messaggio al cittadino: entrambi i casi tornano 422. Ha senso quando la causa era passeggera ed è rientrata (un SMTP tornato su); se invece manca il recapito la riga è SALTATA_NO_RECAPITO e il reinvio non la riguarda.
     * @endpoint post /api/v1/gestione/comunicazioni-outbox/{id}/reinvia
* @param requestParameters
     */
    reinviaComunicazioneOutbox(requestParameters: ReinviaComunicazioneOutboxRequestParams, extraHttpRequestParams?: any): Observable<ComunicazioneOutboxDTO>;

}
